export const LIST_FARM_BACTHES = 'LIST_FARM_BACTHES'
export const SELECT_BATCH = 'SELECT_BATCH'
